
























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import AppPhoneInput from '@/components/AppPhoneInput.vue'
import { ThirdPartyInfoInput } from '@/modules/ThirdParty/interfaces/third-party-form'
import { states } from '@/utils/us_states'

@Component({
  components: {
    AppTextField,
    AppPhoneInput,
    AppTextarea
  }
})
export default class ThirdPartyFormInfo extends Vue {
  @Prop({ type: Object as () => ThirdPartyInfoInput }) value!: ThirdPartyInfoInput

  states = states

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
